<template>
    <div class="">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="vx-card p-4">
                    <div slot="no-body" class="tabs-container">
                        <!-- Content Row -->
                        <div class="vx-row ">
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label required">{{ $t('navMenu.school') }}</label>
                                <vs-input class="w-full" v-model="branchInfo.organizationBranchName"
                                    :disabled="isUpdate" v-validate="'required'" name="organizationBranchName" />
                                <span class="text-danger text-sm">{{ errors.first('organizationBranchName') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.email') }}</label>
                                <vs-input class="w-full" v-model="branchInfo.email" :disabled="isUpdate"
                                    v-validate="'email'" name="email" />
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <vs-input class="w-full" :label="$t('menuOrganization.phoneNumber')"
                                    v-model="branchInfo.phoneNumber" v-validate="'numeric|min:10|max:11'"
                                    name="phoneNumber" />
                                <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.manager') }}</label>
                                <vs-select autocomplete class="w-full" v-model="branchInfo.employeeId">
                                    <vs-select-item :key="index" :value="item.value" :text="item.label"
                                        v-for="(item, index) in employeeData" />
                                </vs-select>
                            </div>
<!--                            <div class="vx-col md:w-1/3 w-full mt-2">-->
<!--                                <label class="vs-input&#45;&#45;label required">Học phí/Tiết dạy</label>-->
<!--                                <vs-input class="vs-input w-full" v-model="sessionTuitionFee" @input="formatInputTuitionFee"-->
<!--                                          type="text" />-->
<!--                            </div>-->
                            <div class="vx-col md:w-2/3 w-full mt-2">
                                <label data-v-8f168c40="" class="vs-input--label required">{{
                                    $t('menuOrganization.locationMap')
                                }}</label>
                                <vs-input class="w-full" v-model="branchInfo.fullAddress"></vs-input>
                                <span class="text-danger text-sm">{{ errors.first('enterAddress') }}</span>
                            </div>
                            <div class="vx-col md:w-2/3 w-full mt-4 flex">
                                <vs-checkbox v-model="option" class="ml-2">
                                    {{
                                    $t('menuOrganization.automaticBirth')
                                }}
                                </vs-checkbox>
                            </div>
                        </div>

                        <!-- Maps -->
                        <!--                        <div class="vx-row mt-2 mb-5">-->
                        <!--                            <div class="vx-col md:w-1/3 w-full">-->
                        <!--                                <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.branchType') }}</label>-->
                        <!--                                <v-select class="" v-model="branchTypeModel" :clearable="false"-->
                        <!--                                          :options="branchTypeOptions"-->
                        <!--                                          data-vv-validate-on="blur" v-validate="'required'" name="organizationType">-->
                        <!--                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>-->
                        <!--                                </v-select>-->
                        <!--                            </div>-->
                        <!--                            <div class="vx-col w-full">-->
                        <!--                                <label data-v-8f168c40="" class="vs-input&#45;&#45;label required">{{-->
                        <!--                                        $t('menuOrganization.locationMap')-->
                        <!--                                    }}</label>-->
                        <!--                                <vs-input class="w-full" v-model="branchInfo.fullAddress"></vs-input>-->
                        <!--                        <google-autocomplete data-v-8f168c40="" type="text" id="map"-->
                        <!--                                                 :placeholder="$t('menuOrganization.enterAddress')" value=""-->
                        <!--                                                 class="vs-inputx vs-input&#45;&#45;input normal hasValue pac-target-input"-->
                        <!--                                                 v-model="branchInfo.fullAddress"-->
                        <!--                                                 ref="address"-->
                        <!--                                                 v-validate="'required'"-->
                        <!--                                                 name="enterAddress"-->
                        <!--                                                 v-on:placechanged="getAddressData"-->
                        <!--                                                 v-on:error="handleError">-->
                        <!--                        </google-autocomplete>-->
                        <!--                        <GmapAutocomplete @place_changed="setPlace" />-->
                        <!--                                <span class="text-danger text-sm">{{ errors.first('enterAddress') }}</span>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <!--                <vx-card>-->
                        <!--                    <GmapMap-->
                        <!--                        :center="center"-->
                        <!--                        :zoom="16"-->
                        <!--                        map-type-id="terrain"-->
                        <!--                        style="width: 100%; height: 50rem">-->
                        <!--                        <GmapMarker-->
                        <!--                            :key="index"-->
                        <!--                            v-for="(marker, index) in markers"-->
                        <!--                            :position="marker.position"-->
                        <!--                            :clickable="true"-->
                        <!--                            country="vi"-->
                        <!--                            @click="center=marker.position"-->
                        <!--                        />-->
                        <!--                    </GmapMap>-->
                        <!--                </vx-card>-->
                        <!-- Save & Reset Button -->
                        <div class="vx-row">
                            <div class="vx-col w-full mb-5">
                                <div class="mt-8 flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                    `${isUpdate ?
                                        $t('button.update') : $t('button.create')}`
                                }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="branchList"
                                        v-if="!branchId">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
/*#vs2__listbox li {*/
/*    position: absolute;*/
/*    z-index: 9999;*/
/*}*/
</style>
<script>
import vSelect from 'vue-select';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import GoogleAutocomplete from "./components/GoogleAutocomplete";
import province from '@/assets/utils/province.js';
import { isAPI, isRouter } from "../../../store/permission";
import { constAPI, constRouter } from "../../../store/constant";

export default {
    name: 'ClientInfomation',
    components: {
        vSelect,
        VueGoogleAutocomplete,
        GoogleAutocomplete,
    },
    props: {
        branchId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            option: false,
            addressMap: null,
            address: '',
            fullAddress: '',
            markerLocal: null,
            addressString: '',
            places: [],
            activeTab: 0,
            branchInfo: {

            },
            input: '',
            isUpdate: false,
            cityOptions: province.getProvince(),
            districtOptions: province.getDistrict('01'),
            subDistrictOptions: province.getSubDistrict('01', '001'),
            branchTypeOptions: [
                { label: this.$t('menuOrganization.null'), value: 0 },
                { label: this.$t('menuOrganization.principalOffice'), value: 1 },
                { label: this.$t('menuOrganization.branch'), value: 2 },
                { label: this.$t('menuOrganization.client'), value: 3 },
            ],
            // mapLocal: '',
            // options: {
            //     zoomControl: false,
            //     mapTypeControl: false,
            //     scaleControl: false,
            //     streetViewControl: false,
            //     rotateControl: false,
            //     fullscreenControl: true,
            //     disableDefaultUi: false
            // },
            // center: {lat: 21.032041, lng: 105.782851},
            // markers: [],
            // currentPlace: null,
            employeeData: [],
            checkBoxData: null,
            // sessionTuitionFee: 0,
        }
    },

    async created() {
        await this.getEmployee()
        let userInfo = JSON.parse(localStorage.getItem('userInfo') || {});
        if (this.$route.query.id || this.branchId) {
            let id = this.branchId ? this.branchId : this.$route.query.id
            this.isUpdate = true;
            this.$crm.post('/organization-branch/all').then((response) => {
                this.$vs.loading.close();
                const dataResult = response.data.find(x => x.id == id);
                this.branchInfo = dataResult;
                this.branchInfo.employeeId = dataResult.employee ? dataResult.employee.employeeId : null;
                this.option = this.branchInfo.enableWorkShift;
                // if (!this.branchInfo.extraLessonSalary) {
                //     this.branchInfo.extraLessonSalary = 0
                // } else this.formattedExtraSalary = this.formatCurrency(this.branchInfo.extraLessonSalary)
                // if (!this.branchInfo.mainLessonSalary) {
                //     this.branchInfo.mainLessonSalary = 0
                // } else this.formattedSalary = this.formatCurrency(this.branchInfo.mainLessonSalary)
                // if (!this.branchInfo.sessionTuitionFee) {
                //     this.branchInfo.sessionTuitionFee = 0
                // } else this.sessionTuitionFee = this.formatCurrency(this.branchInfo.sessionTuitionFee)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        } else {
            this.branchInfo = {
                organizationBranchName: null,
                fullAddress: null,
                organizationBranchType: 3,
                organizationId: userInfo.organization.id,
                phoneNumber: null,
                city: "01",
                district: "001",
                houseNumber: null,
                street: "00001",
                latitude: 0,
                longitude: 0,
                employeeId: null,
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
        // branchTypeModel: {
        //     get() {
        //         return {
        //             label: this.getLabelString(this.branchTypeOptions.find(x => x.value === this.branchInfo.organizationBranchType)),
        //             value: this.branchInfo.organizationBranchType
        //         }
        //     },
        //     set(obj) {
        //         this.branchInfo.organizationBranchType = obj.value
        //     }
        // },
    },
    // watch: {
    //     markerLocal(value) {
    //         const marker = {
    //             lat: value.latitude,
    //             lng: value.longitude
    //         };
    //         this.addMarker(marker);
    //     },
    // },


    methods: {
        // formatCurrency(amount) {
        //     return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
        // },
        // removeDots(input) {
        //     return input.replace(/\./g, '');
        // },
        // formatInputTuitionFee(event) {
        //     let value = event;
        //     value = value.replace(/\D/g, '');
        //     if (value) {
        //         value = Number(value).toLocaleString('vi-VN');
        //     }
        //     this.sessionTuitionFee = value;
        //     this.branchInfo.sessionTuitionFee = this.removeDots(this.sessionTuitionFee)
        // },

        isPermissionUpdate() {
            return isAPI(this, constAPI.organization_branch_edit);
        },
        // getPosition(val) {
        //     this.branchInfo.latitude = val[0].position.lat
        //     this.branchInfo.longitude = val[0].position.lng
        // },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        // getAddressData(addressData, placeResultData, id) {
        //     this.$crm.get(`/organization-branch/place/auto-complete?input=${this.input}`).then(() => {
        //             const marker = {
        //                 lat: this.currentPlace.geometry.location.lat(),
        //                 lng: this.currentPlace.geometry.location.lng()
        //             };
        //             this.geometry = marker
        //             // this.places = [];
        //             this.addMarker(marker);
        //             this.$vs.loading.close();
        //         })
        //         .catch((err) => {
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     this.address = addressData;
        //     this.branchInfo.fullAddress = placeResultData.formatted_address;
        //     this.branchInfo.latitude = addressData.latitude;
        //     this.branchInfo.longitude = addressData.longitude;
        //     this.addMarker(addressData);
        // },
        // handleError(error) {
        //     alert(error);
        // },
        // addMarker(marker) {
        //     const markerShow = {
        //         lat: marker.latitude,
        //         lng: marker.longitude
        //     };
        //     // this.markers = [];
        //     this.markers.push({position: markerShow});
        //     this.places.push(this.currentPlace);
        //     this.center = markerShow;
        //     this.currentPlace = null;
        //     console.log('marker', this.markers)
        //     this.$emit("mapLocation", this.markers);
        // },
        // geolocate: function () {
        //     navigator.geolocation.getCurrentPosition(position => {
        //         this.center = {
        //             lat: position.coords.latitude,
        //             lng: position.coords.longitude
        //         };
        //     });
        // },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;
                const result = await this.$validator.validateAll();
                if (!result) return;
                let url = this.isUpdate ? `/organization-branch/update/${this.branchInfo.id}` : '/organization-branch/create';

                let payload = {
                    city: this.branchInfo.city,
                    code: this.branchInfo.code,
                    district: this.branchInfo.district,
                    email: this.branchInfo.email,
                    employeeId: this.branchInfo.employeeId,
                    fullAddress: this.branchInfo.fullAddress,
                    houseNumber: this.branchInfo.houseNumber,
                    organizationBranchName: this.branchInfo.organizationBranchName,
                    organizationBranchType: this.branchInfo.organizationBranchType,
                    organizationId: this.branchInfo.organizationId,
                    phoneNumber: this.branchInfo.phoneNumber,
                    street: this.branchInfo.street,
                    enableWorkShift: this.option ? 1 : 0,
                    // extraLessonSalary: this.branchInfo.extraLessonSalary,
                    // mainLessonSalary: this.branchInfo.mainLessonSalary,
                    // sessionTuitionFee: this.branchInfo.sessionTuitionFee
                }
                this.$vs.loading();
                this.$crm.post(url, payload).then(res => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? this.$t('button.update') : this.$t('button.create')} trường thành công!`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
                    if (this.isUpdate) {
                        let branch = branchList.filter(x => x.id !== res.data.id)
                        setTimeout(() => {
                            branch.push(res.data);
                            this.$store.dispatch('updateBranchListInfo', branch);
                        })
                    } else {
                        branchList.push(res.data)
                        this.$store.dispatch('updateBranchListInfo', branchList);
                    }
                    this.$store.dispatch('updateBranchListInfo', branchList);
                    if (this.branchId) {
                        this.$eventBus.$emit("update-branch-success", {});
                    } else {
                        this.$router.push('/user/manage-school').catch(() => {
                        })
                    }
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },
        branchList() {
            this.$router.push('/user/manage-school').catch(() => {
            })
        },

        getEmployee() {
            return new Promise((resolve, reject) => {
                let payload = {
                    enabled: true,
                }

                this.$vs.loading()
                this.$crm.post('/employee/all', payload).then(res => {
                    this.$vs.loading.close();
                    if (res.data && res.data.length > 0) {
                        this.employeeData = res.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName
                            }
                        })

                        this.employeeData.unshift({ value: null, label: 'Không xác định' })
                    }
                    resolve()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getAllBranch() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.post('/organization-branch/all').then((response) => {
                    this.$vs.loading.close()
                    this.$store.dispatch('updateBranchListInfo', response.data);
                    resolve(response)
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },
    mounted() {
        // this.$eventBus.$on("address_location", (event) => {
        //     this.branchInfo.fullAddress = event
        //     console.log('map', event)
        // });
        // this.geolocate();
    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>
